import React, { useEffect, useState } from 'react';

import CardContent from '@dashboard/components/CardContent';
import CardListItem from '@dashboard/components/CardListItem';
import CardListItemElement from '@dashboard/components/CardListItemElement';
import ExportView from '@dashboard/components/ExportView';
import SearchInput from '@dashboard/components/Form/components/SearchInput';
import SortInput from '@dashboard/components/Form/components/SortInput';
import CustomersList from '../components/CustomersList';
import useUrlQuery from '@/dashboard/hooks/useUrlQuery';
import { stringify } from 'query-string';
import { useHistory } from 'react-router';

const SORT_DIRECTIONS = {
  ASCENDING: '1',
  DESCENDING: '-1',
};

const SORT_OPTIONS = {
  NEWEST_FIRST: {
    value: 'createdAt',
    direction: SORT_DIRECTIONS.DESCENDING,
    label: 'Newest first',
  },
  OLDEST_FIRST: {
    value: 'createdAt',
    direction: SORT_DIRECTIONS.ASCENDING,
    label: 'Oldest first',
  },
  NAME_ASCENDING: {
    value: 'name',
    direction: SORT_DIRECTIONS.ASCENDING,
    label: 'Name A-Z',
  },
  NAME_DESCENDING: {
    value: 'name',
    direction: SORT_DIRECTIONS.DESCENDING,
    label: 'Name Z-A',
  },
  EMAIL_ASCENDING: {
    value: 'email',
    direction: SORT_DIRECTIONS.ASCENDING,
    label: 'Email A-Z',
  },
  EMAIL_DESCENDING: {
    value: 'email',
    direction: SORT_DIRECTIONS.DESCENDING,
    label: 'Email Z-A',
  },
};

function getSortOptionFromQuery(sortBy, sortDirection) {
  const sortOption = Object.keys(SORT_OPTIONS).find(
    key => SORT_OPTIONS[key].value === sortBy && SORT_OPTIONS[key].direction === sortDirection,
  );

  return sortOption || Object.keys(SORT_OPTIONS)[0];
}

const PageCustomers = ({ page }) => {
  const query = useUrlQuery();
  const history = useHistory();

  const [sortOption, setSortOption] = useState(
    getSortOptionFromQuery(query.sortBy, query.sortDirection),
  );
  const [search, setSearch] = useState(query.search || '');

  useEffect(() => {
    setSearch(query.search || '');
  }, [query.search]);

  useEffect(() => {
    setSortOption(getSortOptionFromQuery(query.sortBy, query.sortDirection));
  }, [query.sortBy, query.sortDirection]);

  const sortBy = SORT_OPTIONS[sortOption].value;
  const sortDirection = SORT_OPTIONS[sortOption].direction;

  const sort = {
    [sortBy]: sortDirection,
  };

  const filter = {};

  let title = 'customers';
  if (page.type === 'form') {
    title = 'leads';
  } else if (page.type === 'event') {
    title = 'guests';
  }

  useEffect(() => {
    const params = {};

    params.sortBy = sortBy;
    params.sortDirection = sortDirection;

    if (search) {
      params.search = search;
    }

    history.replace({
      search: stringify(params),
    });
  }, [sortBy, sortDirection, search, page]);

  return (
    <div className="mb-24 overflow-auto">
      <div className="flex items-center justify-between pb-4">
        <h2 className="text-xl font-medium">Customers</h2>

        <div className="flex items-center gap-x-2">
          <SearchInput
            onChange={setSearch}
            name="search_customers"
            placeholder="Search by email"
            initialValue={search}
          />

          <SortInput options={SORT_OPTIONS} onChange={setSortOption} value={sortOption} />

          <ExportView
            collection="checkout-customers"
            label={title}
            filters={{
              page: page._id,
            }}
          />
        </div>
      </div>

      <CardContent className="overflow-auto mb-20">
        <CardListItem variant="header" className="!bg-gray-50 !mt-0 rounded-t">
          <CardListItemElement size="3xl">Customer</CardListItemElement>
          <CardListItemElement size="xl" align="right">
            Created date
          </CardListItemElement>
        </CardListItem>

        <CustomersList sort={sort} search={search} filter={filter} />
      </CardContent>
    </div>
  );
};

export default PageCustomers;
